import React, { useState } from 'react';
import styles from './Checkout.module.scss'
import Select from 'react-select';
import { Controller } from 'react-hook-form';
import makeAnimated from 'react-select/animated';
import Grid from "../../Grid";
import PlacesAutocompleteField from '../../common/Forms/PlacesAutocompleteField'
const animatedComponents = makeAnimated();

const ShippingForm = ({ app, cardPayment, clearpayPayment, register, errors, control, unregister, sameAsBilling, usStates, setValue }) => {
  return (
    <div>
      <h2 className={styles.header}>
        {app ? '5' : '4'}. Shipping Info
      </h2>

      {(cardPayment || clearpayPayment) && <label className={`${styles.label} ${styles.checkboxLabel}`}>
        <input
          type="checkbox"
          className={styles.sameAsBillingCheckbox}
          onClick={() => unregister(
            ["shipping_address", "shipping_address2", "shipping_city", "shipping_state",
            "shipping_zip"])}
          {...register("same_as_billing")}
        />
        Select if same as Billing Address
      </label>}

      {(sameAsBilling === false || !(cardPayment || clearpayPayment)) &&
      <div>
        <label className={styles.label}>Address Line 1</label>
        <PlacesAutocompleteField
          inputClassName={`${styles.input} ${errors.address && styles.error}`}
          setValue={setValue}
          control={control}
          inputName="shipping_address"
        />

        <label className={styles.label}>Address Line 2 (Apt. / Unit #)</label>
        <input
          className={`${styles.input} ${errors.shipping_address2 && styles.error}`}
          {...register("shipping_address2")}
        />

        <Grid container>
          <Grid item xs={8}>
            <label className={styles.label}>City</label>
            <input
              className={`${styles.input} ${errors.shipping_city && styles.error}`}
              {...register("shipping_city", { required: true })}
            />
          </Grid>
          <Grid item xs={1} />

          <Grid item xs={3}>
            <label className={styles.label} />
            <Controller
              control={control}
              defaultValue={{ value: 'CA', label: 'CA' }}
              name="shipping_state"
              render={({ field, value }) => (
                <Select
                  {...field}
                  className="basic-single"
                  components={animatedComponents}
                  defaultValue={{ value: 'CA', label: 'CA' }}
                  options={usStates}
                  name="shipping_state"
                  value={usStates.find(s => s.value === value)}
                />)}
            />
          </Grid>
        </Grid>

        <Grid container>
          <Grid item xs={8}>
            <label className={styles.label}>Zip Code</label>
            <input
              className={`${styles.input} ${errors.shipping_zip && styles.error}`}
              type="number"
              inputMode='numeric'
              {...register("shipping_zip",
                { required: true,
                  minLength: {
                    value: 5,
                    message: "ZIP code must be at least 5 numbers"
                  }})}
            />
          </Grid>
        </Grid>

        {errors.shipping_zip && errors.shipping_zip.message && (
          <p className={styles.errorMessage}>{errors.shipping_zip.message}</p>
        )}
      </div>}
    </div>
  )
}

export default ShippingForm;
